import React from "react";

import { theme } from "studio-design-system";

export const CarouselButtonNextIcon = ({
  fill = theme.colors.content.tertiary,
}: {
  fill?: string;
}) => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.310934 0.315696C-0.103645 0.734816 -0.103645 1.41186 0.310934 1.83097L4.43546 6.00068L0.310934 10.1704C-0.103645 10.5895 -0.103645 11.2665 0.310934 11.6857C0.725513 12.1048 1.39522 12.1048 1.80979 11.6857L6.68907 6.75294C7.10364 6.33382 7.10364 5.65679 6.68907 5.23767L1.80979 0.30495C1.40585 -0.103423 0.725513 -0.103423 0.310934 0.315696Z"
      fill={fill}
    />
  </svg>
);
